export const ENTITY_CATEGORY = {
  SYSTEM: 0,
  DOMAIN: 1,
  DEPRECATED: 2,
};

export const ENTITY_TYPE_TEXT = 'text';
export const ENTITY_TYPE_NUMERIC_RANGE = 'numeric_range';
export const ENTITY_TYPE_REGEX = 'regex';
export const ENTITY_TYPE_BUDGET = 'budget';
export const ENTITY_TYPE_DATE = 'date';
export const ENTITY_TYPE_CURRENCY = 'number_range';
export const ENTITY_TYPE_TIME = 'time';
export const ENTITY_TYPE_ATTACHMENT = 'attachment';

export const ENTITY_TYPES = [
  ENTITY_TYPE_TEXT,
  ENTITY_TYPE_NUMERIC_RANGE,
  ENTITY_TYPE_REGEX,
  ENTITY_TYPE_BUDGET,
  ENTITY_TYPE_DATE,
  ENTITY_TYPE_CURRENCY,
  ENTITY_TYPE_TIME,
  ENTITY_TYPE_ATTACHMENT,
];

export const ENTITY_SECURITY = [
  {
    title: `Personal`,
    value: true,
    iconType: 'lock-close',
  },
  {
    title: `Non-personal`,
    value: false,
    iconType: 'lock-open',
  },
];

export const ENTITY_META_DATA = {
  [ENTITY_TYPE_TEXT]: {
    name: 'Words & Phrases',
    value: 'text',
    description:
      'This entity is used to collect words and phrases along with their variations.',
    botText: 'What is your favourite dish',
    userText: 'Chicken Biryani',
    iconType: 'entity-email',
    selected: false,
  },
  [ENTITY_TYPE_NUMERIC_RANGE]: {
    name: 'Numbers',
    value: 'numeric_range',
    description:
      'This entity is used to collect numbers within a defined number of digits.',
    botText: 'Enter OTP number',
    userText: '51234',
    iconType: 'entity-numeric-range',
    selected: false,
  },
  [ENTITY_TYPE_REGEX]: {
    name: 'Regex',
    value: 'regex',
    description:
      'This entity is used to detect patterns like email ID, phone number etc. ' +
      'and collect relavent information from user says.',
    botText: 'Tell me your email ID',
    userText: 'My email id in ****@*****.***',
    iconType: 'entity-regex',
    selected: false,
  },
  [ENTITY_TYPE_BUDGET]: {
    name: 'Budget',
    value: 'budget',
    description:
      'This entity is used to collect numbers within a defined number of digits.',
    botText: 'How much do u plan on investing?',
    userText: '5 lakhs',
    iconType: 'budget',
    selected: false,
  },
  [ENTITY_TYPE_DATE]: {
    name: 'Date',
    value: 'date',
    description: 'This entity is used to collect a date from the user message',
    botText: 'When would you like to be reminded?',
    userText: '23rd December, 1990',
    iconType: 'date',
    selected: false,
  },
  [ENTITY_TYPE_TIME]: {
    name: 'Time',
    value: 'time',
    description: 'This entity is used to collect time from the user message',
    botText: 'What time would you like to be reminded?',
    userText: '3 AM',
    iconType: 'time',
    selected: false,
  },
  [ENTITY_TYPE_ATTACHMENT]: {
    name: 'Attachment',
    value: 'attachment',
    description:
      'This entity is used to collect attachments from the user message',
    botText: 'Can you please upload a picture?',
    userText: 'IMG123.png',
    iconType: 'attachment',
    selected: false,
  },
  [ENTITY_TYPE_CURRENCY]: {
    name: 'Currency',
    value: 'currency',
    description: 'This entity is used to collect currency type and value',
    botText: 'What loan amount are you looking for?',
    userText: '$20,000',
    iconType: 'currency',
    selected: false,
  },
};
